import React from 'react'
import Breaking from './components/Breaking'
import Category from './components/Category'
import Foods from './components/Foods'
import Hero from './components/Hero'
import NavBar from './components/NavBar'
const App = () => {
  return (
    <div>
    
      <NavBar />
      <Hero />
      <Breaking />
      <Foods />
      <Category />
    </div>
  )
}

export default App
